<template>
    <div class="mt-8 py-2">
        <div
            @click="close()"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current"> 
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>            
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 pb-2 mx-2">
                {{ trans.direction.direction_ttl }}
            </div>
            <div class="btn btn-sm rounded-full normal-case z-100" @click="clearAll">
                {{ trans.routes.clear }}
            </div>
        </div>
        <div class="">
            <div class="mx-4">
                <div class="">
                    <div class="py-1 z-100 relative">
                        <div class="flex">
                            <div class="flex-1">
                                <label class="mb-2 flex">
                                    <span class="btn btn-circle disabled btn-sm rounded-full mr-1 de-icon notranslate">A</span>
                                    <input
                                        type="search"
                                        :placeholder= "trans.direction.departure"
                                        class="input input-bordered input-sm w-full"
                                        :value="origin"
                                        @keyup="searching"
                                        @focus="focus = 'origin'"
                                    />
                                </label>
                                <label class="flex mb-2">
                                    <span class="btn btn-circle disabled btn-sm rounded-full mr-1 di-icon notranslate">B</span>
                                    <input
                                        type="search"
                                        :placeholder= "trans.direction.destination"
                                        class="input input-bordered input-sm w-full"
                                        :value="destination"
                                        @keyup="searching"
                                        @focus="focus = 'destination'"
                                    />
                                </label>
                            </div>
                            <div class="self-center m-2">
                                <span
                                    class="material-symbols-outlined notranslate fill-current"
                                    @click="reverse"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z"/></svg>
                                </span>
                            </div>
                        </div>
                        <button
                            class="btn btn-outline btn-primary btn-xs justify-start my-1 mx-1"
                            @click="chooseYourLocation"
                            :disabled="isYourLocationLoading"
                        >
                            <span class="material-symbols-outlined notranslate fill-current" v-if="!isYourLocationLoading">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M516-120 402-402 120-516v-56l720-268-268 720h-56Zm26-148 162-436-436 162 196 78 78 196Zm-78-196Z"/></svg>                            </span>
                            <span class="loading loading-xs loading-spinner" v-else></span>
                            <span class="mr-2">
                            {{trans.direction.direction_your_location}}
                            </span>
                        </button>
                        <div v-show="focus && searchSuggestions.length > 0">
                            <div class="divider my-1"></div>
                            <div class="flex justify-between my-2">
                                <div class="text-sm font-bold ml-2 mt-1 text-base-content">
                                    {{ trans.direction.select_location }}
                                </div>
                                <div class="btn btn-square btn-sm btn-ghost">
                                <span class="material-symbols-outlined notranslate fill-current" @click="focus = false">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>                                
                                </span>
                                </div>
                            </div>
                            <div
                                class="overflow-y-auto h-screen directions-content-height"
                            >
                                <table class="table">
                                    <tbody>
                                                <tr
                                                    class="hover"
                                                    style="border-bottom-style: solid;"
                                                    v-for="location in searchSuggestions"
                                                    :key="location.properties.id"
                                                >
                                                    <td @click="choosePlace(location)">
                                                        <div class="flex items-center gap-3">
                                                            <span class="material-symbols-outlined notranslate fill-current">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/></svg>
                                                            </span>
                                                            <div class="text-base-content text-sm break-words" style="overflow-wrap: anywhere;">
                                                                {{ location.properties.title }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                    </tbody>
                                </table>  
                                <div class="text-center mt-2 mx-4" v-if="searchSuggestions.length >= 20">
                                    <div class="font-bold mb-2">{{ trans.direction.show_maximum }}</div>
                                </div>             
                            </div>
                        </div>
                        <div class="tabs tabs-boxed justify-center mt-1">
                            <a
                                class="tab mx-1"
                                :class="{
                                    'tab-active':
                                        profile == 'mapbox/driving-traffic',
                                }"
                            >
                                <span
                                    class="material-symbols-outlined notranslate fill-current"
                                    @click="
                                        switchProfile('mapbox/driving-traffic')
                                    "
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-360h80v-120h140v100l140-140-140-140v100H360q-17 0-28.5 11.5T320-520v160ZM480-80q-15 0-29.5-6T424-104L104-424q-12-12-18-26.5T80-480q0-15 6-29.5t18-26.5l320-320q12-12 26.5-18t29.5-6q15 0 29.5 6t26.5 18l320 320q12 12 18 26.5t6 29.5q0 15-6 29.5T856-424L536-104q-12 12-26.5 18T480-80ZM320-320l160 160 320-320-320-320-320 320 160 160Zm160-160Z"/></svg>                                
                            </span>
                            </a>
                            <a
                                class="tab mx-1"
                                :class="{
                                    'tab-active': profile == 'mapbox/driving',
                                }"
                            >
                                <span
                                    class="material-symbols-outlined notranslate fill-current"
                                    @click="switchProfile('mapbox/driving')"
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l-42 120Zm-32 80v200-200Zm100 160q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5 42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Zm-460 40h560v-200H200v200Z"/></svg>                                
                            </span>
                            </a>
                            <a
                                class="tab mx-1"
                                :class="{
                                    'tab-active': profile == 'mapbox/walking',
                                }"
                            >
                                <span
                                    class="material-symbols-outlined notranslate fill-current"
                                    @click="switchProfile('mapbox/walking')"
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m280-40 112-564-72 28v136h-80v-188l202-86q14-6 29.5-7t29.5 4q14 5 26.5 14t20.5 23l40 64q26 42 70.5 69T760-520v80q-70 0-125-29t-94-74l-25 123 84 80v300h-80v-260l-84-64-72 324h-84Zm260-700q-33 0-56.5-23.5T460-820q0-33 23.5-56.5T540-900q33 0 56.5 23.5T620-820q0 33-23.5 56.5T540-740Z"/></svg>                                
                            </span>
                            </a>
                            <a
                                class="tab mx-1"
                                :class="{
                                    'tab-active': profile == 'mapbox/cycling',
                                }"
                            >
                                <span
                                    class="material-symbols-outlined notranslate fill-current"
                                    @click="switchProfile('mapbox/cycling')"
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M620-740q-33 0-56.5-23.5T540-820q0-33 23.5-56.5T620-900q33 0 56.5 23.5T700-820q0 33-23.5 56.5T620-740ZM432-540l88 92v248h-80v-200L312-512q-14-12-19-25t-5-31q0-18 5.5-30.5T312-624l112-112q13-13 27.5-18.5T484-760q18 0 32.5 5.5T544-736l76 76q27 27 63 43.5t81 16.5v80q-63 0-114-22.5T560-604l-32-32-96 96Zm-232 60q85 0 142.5 57.5T400-280q0 85-57.5 142.5T200-80q-85 0-142.5-57.5T0-280q0-85 57.5-142.5T200-480Zm0 340q57 0 98.5-41.5T340-280q0-57-41.5-98.5T200-420q-57 0-98.5 41.5T60-280q0 57 41.5 98.5T200-140Zm560-340q85 0 142.5 57.5T960-280q0 85-57.5 142.5T760-80q-85 0-142.5-57.5T560-280q0-85 57.5-142.5T760-480Zm0 340q57 0 98.5-41.5T900-280q0-57-41.5-98.5T760-420q-57 0-98.5 41.5T620-280q0 57 41.5 98.5T760-140Z"/></svg>                                
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overflow-y-auto h-screen directions-content-height">
                <div class="mx-4" id="directionInstructions"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
        directionsControl: {
            required: true,
        },
        chosenPlace: {
            type: Object,
            default: function () {
                return null;
            },
        },
        clickOnMapToChoose: {
            type: Boolean,
            required: true,
        },
        alertAllowToAccessLocation: {
            type: String,
            required: true,
        },
        defaultOrigAndDest: {
            type: Array,
            default: [],
        },
        locationResource: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            timeOut: null,
            origin: "",
            destination: "",
            focus: "",
            profile: "mapbox/driving-traffic",
            isYourLocationLoading: false
        };
    },
    computed: {
        searchSuggestions() {
            let search = this[this.focus];
            if (!search) {
                return this.locationResource.slice(0, 20);
            }
            return this.locationResource.filter((el) => {
                let title = el.properties.title;
                return title.match(new RegExp(search, "i"));
            }).slice(0, 20);
        },
    },
    methods: {
        searching(event) {
            if (!this.focus) return;
            var self = this;
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(function () {
                self[self.focus] = event.target.value;
            }, 200);
        },
        choosePlace(location) {
            this[this.focus] = location.properties.title;
            let focusFn =
                "set" +
                this.focus.charAt(0).toUpperCase() +
                this.focus.slice(1);
            this.directionsControl[focusFn](location.geometry.coordinates);
            this.focus = "";
        },
        close() {
            this.$emit("closeDirectionsControl");
            this.$emit('closed');
        },
        chooseYourLocation() {
            var self = this;
            this.isYourLocationLoading = true;
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    self.directionsControl.setOrigin([longitude, latitude]);
                    self.origin = this.trans.direction.direction_your_location;
                    self.isYourLocationLoading = false;
                },
                (error) => {
                    alert(self.alertAllowToAccessLocation);

                    return;
                }
            );
        },
        reverse() {
            this.directionsControl.reverse();
            const origin = this.origin;
            const destination = this.destination;
            this.origin = destination;
            this.destination = origin;
        },
        switchProfile(profile) {
            var instructions = document.getElementsByClassName(
                "directions-control directions-control-instructions"
            )[0];
            if (instructions.style.display == "none") {
                instructions.style.display = "block";
            }
            this.directionsControl.actions.setProfile(profile);
            this.profile = profile;
        },
        clearAll() {
            this.directionsControl.removeRoutes();
            this.origin = "";
            this.destination = "";
        },
    },
    watch: {
        chosenPlace(newVal) {
            if (!this.clickOnMapToChoose || !this.focus) return;

            this.choosePlace(newVal);
            this.$emit("clearChosen");
        },
        defaultOrigAndDest(newVal) {
            this.origin = newVal[0];
            this.destination = newVal[1];
        },
    },
};
</script>
<style>
    .de-icon{
        background: #3bb2d0;
        color: #fff;
    }
    .di-icon{
        background: #8a8acb;
        color: #fff;
    }
    .directions-content-height {
    padding-bottom: 30rem;
    }

@media screen and (max-width: 639px) {
    .directions-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
.mapbox-directions-instructions-wrapper {
    max-height: none!important;
}
</style>
